import { styled } from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  gap: 12px;
  justify-content: space-between;
  align-items: center;

  ${({ theme }) => theme.breakpoints.md.query} {
    flex-direction: column;
    justify-content: stretch;
  }
`;
